export default "__VITE_ASSET__DOeKSM_d__"